module.exports = __webpack_public_path__ + "static/img/logo.8ffa86a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/configure/tusocean/logo.png
// module id = SPSw
// module chunks = 23